/**
 * Cliente Axios configurado
 * Centraliza as configurações de requisições HTTP
 */

import axios from 'axios';

// Cria instância do axios com configurações base
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: process.env.REACT_APP_API_TIMEOUT || 30000, // 30 segundos para requisições do chat com OpenAI
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const publicRoutes = [
      '/auth/login',
      '/auth/register',
      '/auth/forgot-password'
    ];
    // Remove baseURL para comparar apenas o path
    const urlPath = config.url.replace(config.baseURL, '');
    const isPublic = publicRoutes.some(route => urlPath.startsWith(route));
    const token = localStorage.getItem('token');
    if (token && !isPublic) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response) => {
    // Sempre retorna apenas os dados da resposta
    return response.data;
  },
  (error) => {
    // Se o erro for 401 (não autorizado), redireciona para login
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    // Clínica com cobrança vencida — trava na tela de pagamento imediatamente,
    // mesmo que a sessão já estivesse aberta antes do bloqueio entrar em vigor
    if (error.response?.status === 403 && error.response?.data?.error === 'INADIMPLENTE') {
      try {
        const userSalvo = JSON.parse(localStorage.getItem('user') || 'null');
        if (userSalvo) {
          userSalvo.clinica = { ...(userSalvo.clinica || {}), inadimplente: true };
          localStorage.setItem('user', JSON.stringify(userSalvo));
        }
      } catch {}
      if (window.location.pathname !== '/usuario/plano-pro') {
        window.location.href = '/usuario/plano-pro';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
